import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-clay-50" }
const _hoisted_2 = { class: "max-w-5xl mx-auto" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex flex-col flex-1 min-w-0 overflow-visible" }
const _hoisted_5 = { class: "relative z-0 flex flex-1 mb-12 overflow-visible" }
const _hoisted_6 = { class: "relative z-0 flex-1 pt-6 overflow-y-auto focus:outline-hidden xl:order-last" }
const _hoisted_7 = { class: "relative inset-0 px-4 pb-6 sm:px-6 lg:px-8" }
const _hoisted_8 = { class: "h-full rounded-lg" }
const _hoisted_9 = { class: "pt-5 pl-4 pr-4 contentful-tab" }
const _hoisted_10 = { class: "guidesTab" }
const _hoisted_11 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_12 = {
  key: 0,
  class: "max-w-3xl px-4 py-16 mx-auto bg-white border shadow-lg sm:px-6 md:grid md:place-items-center lg:px-8 rounded-2xl border-clay-300"
}
const _hoisted_13 = { class: "mx-auto text-center" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "space-y-3" }
const _hoisted_16 = {
  key: 1,
  class: "px-8 py-4 bg-white border rounded-2xl border-clay-300"
}
const _hoisted_17 = { class: "border-b" }
const _hoisted_18 = { class: "px-4 py-10 mx-auto max-w-7xl sm:px-6 lg:px-8" }
const _hoisted_19 = { class: "items-center justify-between max-w-2xl mx-auto space-y-3 sm:flex gap-x-8 lg:mx-0 lg:max-w-none sm:space-y-0" }
const _hoisted_20 = { class: "items-center sm:flex gap-x-6" }
const _hoisted_21 = { class: "space-y-3" }
const _hoisted_22 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "justify-center max-w-6xl mx-auto mb-10" }
const _hoisted_25 = { class: "pt-10 mb-3 text-2xl font-bold tracking-tight md:text-3xl font-display text-clay-950" }
const _hoisted_26 = { class: "space-x-3 sm:flex" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center gap-x-1.5"
}
const _hoisted_28 = {
  key: 1,
  class: "flex items-center gap-x-1.5"
}
const _hoisted_29 = {
  key: 2,
  class: "flex items-center gap-x-1.5"
}
const _hoisted_30 = {
  key: 0,
  class: "items-center sm:flex gap-x-4 sm:gap-x-6"
}
const _hoisted_31 = {
  key: 0,
  class: "block text-sm font-semibold leading-6 text-gray-900"
}
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 1,
  class: "items-center sm:flex gap-x-4 sm:gap-x-6"
}
const _hoisted_34 = {
  key: 0,
  class: "w-full inline-flex items-center justify-center px-4 py-[calc(theme(spacing.2)-1px)] rounded-full border border-transparent bg-clay-950 text-clay-100 hover:bg-clay-900 hover:text-clay-50 shadow-md whitespace-nowrap text-base font-medium data-[disabled]:bg-clay-50 data-[hover]:bg-clay-900 data-[disabled]:text-clay-600"
}
const _hoisted_35 = { class: "grid grid-cols-4 gap-3 py-6 mt-6 text-powder-900 bg-powder-100 rounded-2xl" }
const _hoisted_36 = { class: "col-span-4 px-8 md:col-span-2" }
const _hoisted_37 = { class: "col-span-4 px-8 md:col-span-2" }
const _hoisted_38 = { class: "col-span-4 px-8 md:col-span-2" }
const _hoisted_39 = { class: "mt-6" }
const _hoisted_40 = { class: "mt-3" }
const _hoisted_41 = { class: "mt-3" }
const _hoisted_42 = { class: "mt-3" }
const _hoisted_43 = { class: "grid grid-cols-1 gap-4 mt-4 sm:grid-cols-3" }
const _hoisted_44 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_45 = ["for"]
const _hoisted_46 = { class: "block text-sm font-light text-gray-600" }
const _hoisted_47 = { class: "mt-3" }
const _hoisted_48 = { class: "divide-y divide-gray-200" }
const _hoisted_49 = { class: "grid gap-6 mt-6 md:grid-cols-4" }
const _hoisted_50 = { class: "sm:col-span-4" }
const _hoisted_51 = { class: "flex justify-center px-6 pt-5 pb-6 mt-1 border-2 border-clay-500 border-dashed rounded-md" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "overflow-hidden bg-gray-100 border rounded-lg shadow-lg aspect-square border-slate-900" }
const _hoisted_54 = ["src"]
const _hoisted_55 = {
  key: 1,
  class: "space-y-1 text-center"
}
const _hoisted_56 = { class: "mt-6" }
const _hoisted_57 = { class: "mt-3" }
const _hoisted_58 = { class: "mt-3" }
const _hoisted_59 = {
  id: "opportunity-comp",
  class: ""
}
const _hoisted_60 = { class: "grid grid-cols-1 gap-4 mt-4 sm:grid-cols-3" }
const _hoisted_61 = ["id", "onUpdate:modelValue", "value"]
const _hoisted_62 = ["for"]
const _hoisted_63 = { class: "block text-sm font-light text-gray-600" }
const _hoisted_64 = { class: "mt-3" }
const _hoisted_65 = { class: "mt-4" }
const _hoisted_66 = { class: "mt-3" }
const _hoisted_67 = { class: "relative mt-1" }
const _hoisted_68 = { class: "flex items-center" }
const _hoisted_69 = ["src"]
const _hoisted_70 = {
  key: 0,
  class: "mt-2 text-sm font-medium text-clay-800"
}
const _hoisted_71 = ["src"]
const _hoisted_72 = ["href"]
const _hoisted_73 = { class: "mt-6" }
const _hoisted_74 = { class: "mt-3" }
const _hoisted_75 = { class: "mt-3" }
const _hoisted_76 = { class: "mt-3" }
const _hoisted_77 = { class: "mt-3" }
const _hoisted_78 = { class: "py-3 mt-10 text-center" }
const _hoisted_79 = { class: "py-3 mt-10 space-x-3 space-y-3 text-center border rounded-lg border-clay-300" }
const _hoisted_80 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_81 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_82 = { class: "flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full" }
const _hoisted_83 = { class: "mt-3 text-center sm:mt-5" }
const _hoisted_84 = { class: "mt-2" }
const _hoisted_85 = { class: "text-sm text-clay-800" }
const _hoisted_86 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import {computed, onMounted, Ref, ref, nextTick, watchEffect } from "vue";
import {client, fileValidators, trackEvent} from '@/shared';
import {
    DeleteOpportunityPostedByMe,
    GetOpportunityPostedByMe,
    GetOpportunityPostedByMeResponse,
    MakeOpportunityInvisible,
    MakeOpportunityVisible,
    OpportunityDTO,
    OpportunityDTOLightweight, PublishDraftedOpportunity, PublishDraftedOpportunityResponse,
    SearchGuidesByCategory,
    SearchGuidesByCategoryResponse,
    ShowDto,
    TheatreCompanyDTO,
    UpdateOpportunity
} from "@/dtos";
// @ts-ignore
import Uploadcare from 'uploadcare-vue/src/Uploadcare.vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete/src/VueGoogleAutocomplete.vue'
import {ResponseStatus} from "@servicestack/client";
import {CheckIcon, ChevronDownIcon, TrashIcon, ShoppingCartIcon, ClockIcon} from '@heroicons/vue/20/solid';
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOption,
    ComboboxOptions, Dialog,
    DialogPanel, DialogTitle,
    Switch, TransitionChild, TransitionRoot
} from '@headlessui/vue';
import SaSocialShare from "@/main/components/SaSocialShare.vue";
import {store} from "@/store";
import SaCombobox from "@/main/components/SaCombobox.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateOpportunity',
  props: {
    id: {},
    categoryOptions: {},
    compensationOptions: {},
    formatOptions: {},
    unionOptions: {}
  },
  setup(__props: any) {

const props = __props;

let responseStatus = ref({});
let opportunity: Ref<OpportunityDTO> = ref(new OpportunityDTO({}));
let updateRequest: Ref<UpdateOpportunity> = ref(new UpdateOpportunity({}));
let submitSuccessful: Ref<Boolean> = ref(false);

const categoryOptions = computed(() => {
    return props.categoryOptions;
});

const formatOptions = computed(() => {
    return props.formatOptions;
});

const unionOptions = computed(() => {
    return props.unionOptions;
});

let shows: Ref<ShowDto[]> = ref([]);
const selectedShow = ref({} as ShowDto);
const query = ref('');

const getShows = async (event: any) => {
    query.value = event.target.value;
    if (query.value !== '' && query.value.length >= 3) {
        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory({
                q: query.value,
                category: 'Shows'
            }
        ))
            .then(res => {
                shows.value = res.results as ShowDto[];
            });
    }
};

const displaySelectedShow = (selectedShow: ShowDto) => {
    let display = '';

    if (selectedShow) {
        display = `${selectedShow.title} (${selectedShow.category})`;
    }
    return display;
};


const selectedCompany = ref({} as TheatreCompanyDTO);

const isFetching = ref(true);
onMounted(async () => {

    await client.get<GetOpportunityPostedByMeResponse>(new GetOpportunityPostedByMe({id: props.id}))
        .then(res => {
            opportunity.value = res.opportunity;
            selectedCompany.value = res.selectedCompany || {name: res.opportunity.companyName};
            selectedShow.value = res.selectedShow;
            document.title = "New Title"
            
            nextTick(() => {
                if (addressInput.value) {
                    addressInput.value.update(opportunity.value.address);
                }
            });

            updateRequest.value = {
                id: opportunity.value.id,
                title: opportunity.value.title,
                category: opportunity.value.category,
                format: opportunity.value.auditionOrInterviewFormat,
                compensation: opportunity.value.compensation,
                union: opportunity.value.union,
                description: opportunity.value.description,
                webUrl: opportunity.value.webUrl,
                email: opportunity.value.email,
                phone: opportunity.value.phone,
                image: opportunity.value.imageUrl,
                address: opportunity.value.address,
            };

            isFetching.value = false;
        });

});

const isSubmitting = ref(false);

const submit = async () => {

    isSubmitting.value = true;
    submitSuccessful.value = false;
    
    let request = updateRequest.value;
    if (selectedShow.value && selectedShow.value.title) {
        request.showId = selectedShow.value.id;
    }

    await client.post<ResponseStatus>(new UpdateOpportunity(request))
        .then(response => {
            submitSuccessful.value = true;
            responseStatus.value = {};
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

    isSubmitting.value = false;
};

const toggleVisibility = async (opportunity: OpportunityDTOLightweight) => {
    if (opportunity.isVisible) {
        opportunity.isVisible = false;
        await client.post<ResponseStatus>(new MakeOpportunityInvisible({id: opportunity.id}))
            .then(async () => {
                responseStatus.value = {};
            })
            .catch(e => {
                opportunity.isVisible = true;
                responseStatus.value = e.responseStatus;
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
    } else {

        opportunity.isVisible = true;
        await client.post<ResponseStatus>(new MakeOpportunityVisible({id: opportunity.id}))
            .then(async () => {
                responseStatus.value = {};
            })
            .catch(e => {
                opportunity.isVisible = false;
                responseStatus.value = e.responseStatus;
                window.scrollTo(0,100);
            });
    }
}

const isPublishingDrafted = ref(false);
const publishDraftedSuccessful = ref(false);

const publishDrafted = async () => {
    isPublishingDrafted.value = true;
    publishDraftedSuccessful.value = false;

    await client.post<PublishDraftedOpportunityResponse>(new PublishDraftedOpportunity({
            id: opportunity.value.id
        }))
        .then(response => {
            
            trackEvent( 'opportunity_published', {
                content_id: response.id,
                content_title: opportunity.value.title,
                content_type: opportunity.value.type,
                item_category: opportunity.value.category,
                member_status: store.saUserSession.subscriptionType
            }, true, false);
            
            publishDraftedSuccessful.value = true;
            responseStatus.value = {};
            window.location.href = `/${response.id}/publish-draft/success`;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo(0,100);
        });
    isPublishingDrafted.value = false;
};

const isOpen = ref(false);
const openConfirmation = async (opportunity: any) => {
    isOpen.value = true;
    opportunityToDelete.value = opportunity;
}
const closeConfirmation = async () => {
    isOpen.value = false;
}
const opportunityToDelete = ref({});
const deleteSuccessful: Ref<Boolean> = ref(false);
const deleteOpportunity = async (opportunity: OpportunityDTO) => {
    await client.delete<ResponseStatus>(new DeleteOpportunityPostedByMe({id: opportunity.id}))
        .then(async () => {
            isOpen.value = false;
            deleteSuccessful.value = true;
            responseStatus.value = {};
            window.location.href = '/my-posts/opportunities/auditions-jobs/';
        })
}

const generateOpportunityUrl = (opportunity: any) => {
    return `${window.location.origin}/${opportunity.id}/${opportunity.slug}`
}

const addressInput = ref(null);
const onPlaceChanged = async (_: any, placeResultData: any) => {
    updateRequest.value.address = placeResultData.formatted_address;
};

const removeLogo = async () => {
    updateRequest.value.image = "";
}

const onUploadSuccess = async (response: any) => {
    console.log(response);
    updateRequest.value.image = response.cdnUrl;
}

const onUploadImageFailed = async (response: any) => {
    console.log({response});
}

watchEffect(() => {
    document.title = `${updateRequest.value.title ?? "Update Listing..."} | StageAgent`
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (isFetching.value)
                          ? (_openBlock(), _createBlock(SkeletonCard, {
                              key: 0,
                              class: "mt-4",
                              "card-style": "long",
                              "num-of-cards": 4
                            }))
                          : (_openBlock(), _createElementBlock("section", _hoisted_11, [
                              (_unref(submitSuccessful) || publishDraftedSuccessful.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _createElementVNode("main", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                          _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "text-3xl font-bold tracking-tight text-gray-900 md:text-4xl" }, " Thank you!", -1)),
                                          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-lg font-medium text-center text-clay-950" }, " Your post has been updated.", -1)),
                                          (_unref(opportunity).isVisible)
                                            ? (_openBlock(), _createBlock(SaSocialShare, {
                                                key: 0,
                                                title: _unref(opportunity).title,
                                                url: generateOpportunityUrl(_unref(opportunity))
                                              }, null, 8, ["title", "url"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _cache[15] || (_cache[15] = _createStaticVNode("<p class=\"my-8 text-center\"><svg id=\"fi_7453049\" enable-background=\"new 0 0 479.211 479.211\" height=\"90\" viewBox=\"0 0 479.211 479.211\" width=\"90\" xmlns=\"http://www.w3.org/2000/svg\" class=\"mx-auto\"><path d=\"m364.83 353.953c37.84-33.05 61.75-81.66 61.75-135.85 0-99.58-80.73-180.31-180.31-180.31s-180.31 80.73-180.31 180.31c0 54.2 23.91 102.81 61.76 135.86l-23.33 97.49c-2.41 10.08 5.23 19.76 15.59 19.76h28.89c8.5 0 15.53-6.65 16-15.15l1.32-23.92h160.17l1.32 23.92c.46 8.5 7.49 15.15 16 15.15h28.88c10.36 0 18-9.68 15.59-19.76z\" fill=\"#ffd9ad\"></path><path d=\"m363.68 471.213h-20c-8.51 0-15.535-6.65-16-15.15l-4.14-75c7.11-3.37 13.96-7.21 20.52-11.45.099 2.259-.656-15.948 3.62 82.53.465 10.699 7.49 19.07 16 19.07z\" fill=\"#ffebd2\"></path><path d=\"m125.12 471.213h-5.14c-10.36 0-18-9.68-15.59-19.76l23.33-97.49c5.97 5.22 12.29 10.05 18.93 14.45-21.751 95.489-24.997 94.29-21.53 102.8z\" fill=\"#ffebd2\"></path><path d=\"m323.54 381.063 2.82 51.08h-160.17l2.81-51.08c47.438 22.544 104.6 23.733 154.54 0z\" fill=\"#ffca8c\"></path><path d=\"m246.27 37.793c-99.58 0-180.31 80.73-180.31 180.31 0 54.2 23.91 102.81 61.76 135.86 67.181 58.714 168.597 59.821 237.11-.01 37.84-33.05 61.75-81.66 61.75-135.85 0-99.58-80.73-180.31-180.31-180.31z\" fill=\"#ff6d7a\"></path><path d=\"m101.96 234.103c0 65.838 35.483 124.378 89.59 155.85-72.681-23.04-125.59-91.266-125.59-171.85 0-99.58 80.73-180.31 180.31-180.31 33.09 0 64.1 8.91 90.75 24.47-115.677-36.841-235.06 49.312-235.06 171.84z\" fill=\"#ff8c95\"></path><ellipse cx=\"246.27\" cy=\"218.103\" fill=\"#eef7ff\" rx=\"126.41\" ry=\"126.41\" transform=\"matrix(.707 -.707 .707 .707 -82.091 238.02)\"></ellipse><path d=\"m246.27 143.713c-41.08 0-74.39 33.3-74.39 74.39 0 41.08 33.31 74.38 74.39 74.38 41.09 0 74.39-33.3 74.39-74.38 0-41.091-33.3-74.39-74.39-74.39z\" fill=\"#ff6d7a\"></path><circle cx=\"246.27\" cy=\"218.103\" fill=\"#eef7ff\" r=\"24\"></circle><path d=\"m465.35 43.083-47.4 32.21-22.57-3.36.59-22.81 39.91-41.12 3.82 26.7z\" fill=\"#ffebd2\"></path><path d=\"m438.04 23.083-32.07 33.04-.45 17.32-10.14-1.51.59-22.81 39.91-41.12z\" fill=\"#fff3e4\"></path><path d=\"m78.62 159.133 10.74 20.14-18.69 13.1-56.8-7.6 19.19-18.96-8.53-25.591z\" fill=\"#ffebd2\"></path><path d=\"m89.36 179.273-7.18 5.029-7.56-14.17-45.41-15.879-4.68-14.031 54.09 18.911z\" fill=\"#fff3e4\"></path><g><path d=\"m405.764 117.942c-2.352-3.737-7.29-4.863-11.032-2.511-3.739 2.354-4.863 7.292-2.511 11.032 17.244 27.405 26.359 59.093 26.359 91.636 0 95.012-77.297 172.309-172.309 172.309-102.151 0-182.604-89.046-171.263-191.332.693-.448-2.73 1.943 15.991-11.186l23.116 5.53c-15.454 82.276 48.029 159.089 132.156 159.089 74.114 0 134.41-60.296 134.41-134.41 0-23.403-6.109-46.451-17.666-66.653-2.194-3.835-7.081-5.164-10.917-2.972-3.835 2.194-5.165 7.082-2.972 10.917 10.176 17.786 15.555 38.088 15.555 58.708 0 65.292-53.118 118.41-118.41 118.41-73.922 0-129.597-67.258-116.565-139.358l35.12 8.409c-7.689 49.398 30.726 94.926 81.445 94.926 60.67 0 100.025-63.365 74.581-117.434-1.882-3.997-6.647-5.712-10.646-3.831-3.997 1.882-5.713 6.647-3.831 10.646 20.64 43.857-11.538 94.619-60.104 94.619-40.404 0-71.159-35.874-65.824-75.195 11.462 2.726 10.237 2.375 10.931 2.375 3.616 0 6.896-2.47 7.774-6.142 1.027-4.297-1.623-8.613-5.92-9.641l-98.512-23.553-9.041-16.957c-.945-1.772-2.522-3.125-4.418-3.788l-54.092-18.916c-6.265-2.19-12.329 3.788-10.229 10.083l6.959 20.868-15.649 15.464c-4.719 4.665-2.016 12.738 4.562 13.62l46.133 6.179c-6.332 61.725 17.932 119.039 59.912 157.726l-22.246 92.984c-3.617 15.117 7.845 29.618 23.368 29.618h28.885c12.752 0 23.29-9.974 23.991-22.706l.901-16.361h105.564c4.418 0 8-3.582 8-8s-3.582-8-8-8h-104.681l.4-7.26c.243-4.412-3.136-8.186-7.548-8.429-4.419-.239-8.185 3.137-8.428 7.548l-2.183 39.622c-.234 4.254-3.755 7.586-8.015 7.586h-28.885c-5.194 0-9.014-4.853-7.808-9.896l20.386-85.212c54.371 41.365 124.488 48.571 183.626 24.84l3.501 63.561c.701 12.733 11.239 22.707 23.991 22.707h28.885c15.545 0 26.98-14.523 23.368-29.618l-12.69-53.046c-1.027-4.297-5.349-6.945-9.642-5.919-4.297 1.028-6.947 5.345-5.919 9.642l12.69 53.046c1.208 5.051-2.622 9.896-7.808 9.896h-28.885c-4.26 0-7.781-3.332-8.015-7.587l-3.845-69.794c99.581-50.994 132.131-175.42 73.949-267.889zm-365.113 45.338-3.377-10.127 35.756 12.504 5.935 11.131-10.329 7.243-37.545-5.024 7.595-7.505c2.167-2.143 2.93-5.33 1.965-8.222z\"></path><path d=\"m278.272 218.099c0-17.645-14.355-32-32-32s-32 14.355-32 32 14.355 32 32 32c17.644 0 32-14.355 32-32zm-48 0c0-8.822 7.178-16 16-16s16 7.178 16 16-7.178 16-16 16-16-7.177-16-16z\"></path><path d=\"m467.829 35.476-20.913-6.828-3.114-21.778c-.941-6.568-9.039-9.201-13.66-4.439l-39.911 41.119c-1.399 1.441-2.205 3.356-2.257 5.365l-.498 19.209-13.65 11.465c-85.087-78.539-220.871-62.161-284.911 35.039-3.54 5.373.414 12.402 6.673 12.402 2.6 0 5.15-1.266 6.688-3.6 58.224-88.374 181.245-103.745 259.192-33.462l-29.386 24.682c-61.502-51.125-156.261-38.05-200.133 32.732-3.321 5.358.592 12.216 6.792 12.216 2.677 0 5.293-1.344 6.808-3.786 38.104-61.476 119.819-73.574 174.054-30.68l-28.446 23.893c-31.821-20.7-75.058-17.434-103.316 10.994-5.022 5.053-1.385 13.64 5.674 13.64 2.055 0 4.11-.787 5.674-2.36 21.505-21.635 53.853-25.212 79.016-11.395l-7.677 6.448c-5.712 4.798-2.284 14.126 5.149 14.126 1.816 0 3.643-.615 5.142-1.874l116.947-98.227c20.879 3.11 19.38 2.915 20.186 2.915 1.595 0 3.163-.478 4.497-1.384l47.394-32.211c5.486-3.729 4.294-12.163-2.014-14.221zm-51.79 31.443-12.479-1.856.327-12.61 26.383-27.181 1.511 10.569c.432 3.017 2.54 5.526 5.437 6.472l10.15 3.314z\"></path></g></svg></p><div class=\"flex justify-center mt-10 space-x-3 sm:border-l sm:border-transparent sm:pl-6\"><a class=\"rounded-sm bg-clay-950 px-2.5 py-1.5 font-semibold text-clay-100 hover:bg-clay-900 hover:text-clay-50 hover:shadow-sm min-w-full\" href=\"/my-posts/opportunities/auditions-jobs\"> Manage my Posts</a></div>", 2))
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("form", _hoisted_16, [
                                    _createVNode(ErrorSummary, { "response-status": _unref(responseStatus) }, null, 8, ["response-status"]),
                                    _createElementVNode("div", _hoisted_17, [
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", _hoisted_19, [
                                          _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                              _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-sm" }, [
                                                _createElementVNode("a", { href: "/my-posts/opportunities/auditions-jobs" }, "Back to My Listings")
                                              ], -1)),
                                              (_unref(opportunity).isVisible)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                                                    _createElementVNode("a", {
                                                      href: `/${_unref(opportunity).id}/${_unref(opportunity).slug}`
                                                    }, "View Listing", 8, _hoisted_23)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("h1", _hoisted_25, " Update " + _toDisplayString(_unref(updateRequest).title ?? "Your Listing"), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_26, [
                                                (_unref(opportunity).isVisible)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[16] || (_cache[16] = [
                                                      _createElementVNode("div", { class: "flex-none p-1 rounded-full bg-emerald-500/20" }, [
                                                        _createElementVNode("div", { class: "h-1.5 w-1.5 rounded-full bg-emerald-500" })
                                                      ], -1),
                                                      _createElementVNode("p", { class: "text-xs leading-5 text-clay-800" }, " Visible", -1)
                                                    ])))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[17] || (_cache[17] = [
                                                      _createElementVNode("div", { class: "flex-none p-1 rounded-full bg-orange-500/20" }, [
                                                        _createElementVNode("div", { class: "h-1.5 w-1.5 rounded-full bg-orange-500" })
                                                      ], -1),
                                                      _createElementVNode("p", { class: "text-xs leading-5 text-clay-800" }, " Hidden", -1)
                                                    ]))),
                                                (!_unref(opportunity).isLocked)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                      _createVNode(_unref(Switch), {
                                                        disabled: _unref(opportunity).isArchived || _unref(opportunity).isLocked,
                                                        modelValue: _unref(opportunity).isVisible,
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(opportunity).isVisible) = $event)),
                                                        class: _normalizeClass([_unref(opportunity).isVisible ? 'bg-emerald-500' : 'bg-gray-200', 'relative inline-flex shrink-0 h-5 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-emerald-400']),
                                                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (toggleVisibility(_unref(opportunity))), ["prevent"])),
                                                        title: "Toggle Visible/Hidden"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", {
                                                            class: _normalizeClass([_unref(opportunity).isVisible ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-4 w-4 rounded-full bg-white shadow-sm transform ring-0 transition ease-in-out duration-200']),
                                                            "aria-hidden": "true"
                                                          }, null, 2)
                                                        ]),
                                                        _: 1
                                                      }, 8, ["disabled", "modelValue", "class"])
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]),
                                          (_unref(store).saUserSession.subscriptionType !== 'pro')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                (_unref(opportunity).unlockedUntilInPstAsString != 'N/A')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Expires on " + _toDisplayString(_unref(opportunity).unlockedUntilInPstAsString), 1))
                                                  : _createCommentVNode("", true),
                                                (_unref(opportunity).canBeUnlocked)
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 1,
                                                      href: `/${_unref(opportunity).id}/checkout`,
                                                      class: "inline-flex items-center gap-x-1 p-2 text-sm font-semibold text-white rounded-md shadow-sm bg-electric-600 hover:bg-electric-700 focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-electric-700"
                                                    }, [
                                                      (_unref(opportunity).unlockedUntilInPstAsString != 'N/A')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createVNode(_unref(ClockIcon), {
                                                              class: "w-4 h-4",
                                                              title: "Extend"
                                                            }),
                                                            _cache[19] || (_cache[19] = _createElementVNode("span", null, "Extend", -1))
                                                          ], 64))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createVNode(_unref(ShoppingCartIcon), {
                                                              class: "w-4 h-4",
                                                              title: "Publish"
                                                            }),
                                                            _cache[20] || (_cache[20] = _createElementVNode("span", null, "Publish", -1))
                                                          ], 64))
                                                    ], 8, _hoisted_32))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_unref(store).saUserSession.subscriptionType === 'pro'
                                                                    && _unref(opportunity).isLocked
                                                                    && _unref(opportunity).canBeUnlocked)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                (isPublishingDrafted.value)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Publishing Opportunity... "))
                                                  : (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      class: "inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-white uppercase border border-transparent rounded-md hover:shadow-lg hover:bg-clay-700 bg-gradient-to-r from-cyan-500 to-clay-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-gray-900",
                                                      type: "submit",
                                                      onClick: _withModifiers(publishDrafted, ["prevent"])
                                                    }, " Publish Opportunity "))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "block font-bold tracking-tight font-display" }, " Organization", -1)),
                                        _createElementVNode("p", null, _toDisplayString(_unref(opportunity).companyName), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_37, [
                                        _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "block font-bold tracking-tight font-display" }, " Date Range", -1)),
                                        _createElementVNode("p", null, _toDisplayString(_unref(opportunity).datesAsString), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_38, [
                                        _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "block font-bold tracking-tight font-display" }, " Primary Region", -1)),
                                        _createElementVNode("p", null, _toDisplayString(_unref(opportunity).regionName), 1)
                                      ])
                                    ]),
                                    _cache[47] || (_cache[47] = _createElementVNode("h1", { class: "mt-8 mb-3 text-2xl font-bold tracking-tight font-display text-clay-950" }, " Edit Your Listing", -1)),
                                    _createElementVNode("div", _hoisted_39, [
                                      _cache[30] || (_cache[30] = _createElementVNode("div", { class: "text-red-600" }, [
                                        _createTextVNode(" * "),
                                        _createElementVNode("span", { class: "text-clay-950" }, " Required field")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_40, [
                                        _cache[24] || (_cache[24] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "title"
                                        }, [
                                          _createTextVNode("Audition / Job Title"),
                                          _createElementVNode("span", { class: "text-red-600" }, "*")
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          id: "title",
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(updateRequest).title) = $event)),
                                          class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                                          name: "title",
                                          placeholder: "e.g. Auditions for West Side Story",
                                          type: "text"
                                        }, null, 512), [
                                          [_vModelText, _unref(updateRequest).title]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_41, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "category"
                                        }, [
                                          _createTextVNode("Category "),
                                          _createElementVNode("span", { class: "text-red-600" }, "*")
                                        ], -1)),
                                        _createVNode(SaCombobox, {
                                          id: "category",
                                          modelValue: _unref(updateRequest).category,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(updateRequest).category) = $event)),
                                          options: categoryOptions.value,
                                          name: "category"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("fieldset", null, [
                                          _cache[26] || (_cache[26] = _createElementVNode("legend", { class: "block font-bold tracking-tight font-display text-clay-950" }, [
                                            _createTextVNode(" Audition / Interview Format "),
                                            _createElementVNode("span", { class: "text-red-600" }, "*")
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_43, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formatOptions.value, (format) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: format.name,
                                                class: "flex p-4 mb-4 border border-clay-500 opportunity-select rounded-2xl bg-clay-50"
                                              }, [
                                                _withDirectives(_createElementVNode("input", {
                                                  id: format.name,
                                                  "onUpdate:modelValue": ($event: any) => ((_unref(updateRequest).format) = $event),
                                                  value: format.name,
                                                  class: "w-4 h-4 mt-1 border-clay-500 text-clay-600 focus:ring-clay-500",
                                                  name: "format",
                                                  type: "radio"
                                                }, null, 8, _hoisted_44), [
                                                  [_vModelRadio, _unref(updateRequest).format]
                                                ]),
                                                _createElementVNode("label", {
                                                  for: format.name,
                                                  class: "block ml-3 font-medium text-gray-700"
                                                }, [
                                                  _createTextVNode(_toDisplayString(format.name) + " ", 1),
                                                  _createElementVNode("span", _hoisted_46, _toDisplayString(format.description), 1)
                                                ], 8, _hoisted_45)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("div", _hoisted_48, [
                                          _createElementVNode("div", _hoisted_49, [
                                            _createElementVNode("div", _hoisted_50, [
                                              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block font-bold tracking-tight font-display text-clay-950" }, [
                                                _createTextVNode(" Cover Image "),
                                                _createElementVNode("span", { class: "text-xs font-medium text-clay-800" }, "(optional)")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_51, [
                                                (_unref(updateRequest).image && _unref(updateRequest).image.length > 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                      _createElementVNode("div", _hoisted_53, [
                                                        _createElementVNode("img", {
                                                          src: _unref(updateRequest).image,
                                                          class: "object-cover object-center"
                                                        }, null, 8, _hoisted_54)
                                                      ]),
                                                      _createElementVNode("button", {
                                                        class: "relative block min-w-full px-8 py-2 mt-2 text-sm font-medium text-center text-gray-900 border border-transparent rounded-md bg-clay-50 hover:bg-clay-200",
                                                        type: "button",
                                                        onClick: _withModifiers(removeLogo, ["prevent"])
                                                      }, [
                                                        _createVNode(_unref(TrashIcon), { class: "inline-block w-4 h-4 text-clay-800 hover:text-clay-700" }),
                                                        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "inline-block pt-1 ml-2 text-clay-800" }, "Delete", -1))
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                      _createVNode(Uploadcare, {
                                                        imagesOnly: true,
                                                        validators: _unref(fileValidators),
                                                        crop: "400x400 upscale",
                                                        publicKey: "c1ecae68d0087aa3986a",
                                                        tabs: "file url facebook gdrive dropbox instagram evernote flickr skydrive",
                                                        onError: onUploadImageFailed,
                                                        onSuccess: _cache[4] || (_cache[4] = (response) => onUploadSuccess(response))
                                                      }, {
                                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                          _createElementVNode("svg", {
                                                            "aria-hidden": "true",
                                                            class: "w-12 h-12 mx-auto text-clay-800",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            viewBox: "0 0 48 48"
                                                          }, [
                                                            _createElementVNode("path", {
                                                              d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
                                                              "stroke-linecap": "round",
                                                              "stroke-linejoin": "round",
                                                              "stroke-width": "2"
                                                            })
                                                          ], -1),
                                                          _createElementVNode("div", { class: "flex text-sm text-gray-600" }, [
                                                            _createElementVNode("a", { class: "relative flex items-center justify-center px-8 py-2 text-sm font-medium text-white border border-transparent rounded-md bg-clay-800 hover:bg-clay-950" }, "Upload a File")
                                                          ], -1),
                                                          _createElementVNode("p", { class: "text-xs text-clay-800" }, " PNG, JPG, GIF up to 4MB ", -1)
                                                        ])),
                                                        _: 1
                                                      }, 8, ["validators"])
                                                    ]))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _cache[37] || (_cache[37] = _createElementVNode("hr", { class: "border-gray-200" }, null, -1)),
                                      _createElementVNode("div", _hoisted_57, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "union"
                                        }, [
                                          _createTextVNode("Union Requirements "),
                                          _createElementVNode("span", { class: "text-red-600" }, "*")
                                        ], -1)),
                                        _createVNode(SaCombobox, {
                                          id: "union",
                                          modelValue: _unref(updateRequest).union,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(updateRequest).union) = $event)),
                                          options: unionOptions.value,
                                          name: "union"
                                        }, null, 8, ["modelValue", "options"])
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("fieldset", _hoisted_59, [
                                          _cache[32] || (_cache[32] = _createElementVNode("legend", { class: "block font-bold tracking-tight font-display text-clay-950" }, [
                                            _createTextVNode(" Compensation "),
                                            _createElementVNode("span", { class: "text-red-600" }, "*")
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_60, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compensationOptions, (compensation) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: compensation.name,
                                                class: "flex p-4 mb-4 border border-clay-500 opportunity-select rounded-2xl bg-clay-50"
                                              }, [
                                                _withDirectives(_createElementVNode("input", {
                                                  id: compensation.name,
                                                  "onUpdate:modelValue": ($event: any) => ((_unref(updateRequest).compensation) = $event),
                                                  value: compensation.name,
                                                  class: "w-4 h-4 mt-1 border-clay-500 text-clay-600 focus:ring-clay-500",
                                                  name: "compensation",
                                                  type: "radio"
                                                }, null, 8, _hoisted_61), [
                                                  [_vModelRadio, _unref(updateRequest).compensation]
                                                ]),
                                                _createElementVNode("label", {
                                                  for: compensation.name,
                                                  class: "block ml-3 font-medium text-gray-700"
                                                }, [
                                                  _createTextVNode(_toDisplayString(compensation.name) + " ", 1),
                                                  _createElementVNode("span", _hoisted_63, _toDisplayString(compensation.description), 1)
                                                ], 8, _hoisted_62)
                                              ]))
                                            }), 128))
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_64, [
                                        _cache[33] || (_cache[33] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "description"
                                        }, [
                                          _createTextVNode("Description "),
                                          _createElementVNode("small", null, "(Max. 10000 characters)"),
                                          _createElementVNode("span", { class: "text-red-600" }, " *")
                                        ], -1)),
                                        _cache[34] || (_cache[34] = _createElementVNode("p", { class: "text-sm text-clay-800" }, "Describe your opportunity below. Include all relevant details such as directions, sign up forms, ticket prices, discount codes etc.", -1)),
                                        _createElementVNode("div", _hoisted_65, [
                                          _withDirectives(_createElementVNode("textarea", {
                                            id: "description",
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(updateRequest).description) = $event)),
                                            class: "h-32 resize p-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-clay-900 outline-1 -outline-offset-1 outline-clay-300 placeholder:text-clay-900 focus:outline-2 focus:-outline-offset-2 focus:outline-clay-600 sm:text-sm/6",
                                            name: "description"
                                          }, null, 512), [
                                            [_vModelText, _unref(updateRequest).description]
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_66, [
                                        _cache[35] || (_cache[35] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "selectedShow"
                                        }, [
                                          _createTextVNode("Related StageAgent Guide "),
                                          _createElementVNode("span", { class: "text-xs text-clay-800" }, "(optional)")
                                        ], -1)),
                                        _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-sm text-clay-800" }, "Include a link to a StageAgent guide", -1)),
                                        _createVNode(_unref(Combobox), {
                                          modelValue: selectedShow.value,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedShow).value = $event)),
                                          as: "div",
                                          nullable: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_67, [
                                              _createVNode(_unref(ComboboxInput), {
                                                id: "selectedShow",
                                                "display-value": displaySelectedShow,
                                                class: "w-full py-2 pl-3 pr-10 bg-white border border-clay-500 rounded-md shadow-sm focus:border-clay-500 focus:outline-hidden focus:ring-1 focus:ring-clay-500 sm:text-sm",
                                                placeholder: "Start typing and select from the dropdown list",
                                                onChange: getShows
                                              }),
                                              _createVNode(_unref(ComboboxButton), {
                                                class: "absolute inset-y-0 right-0 flex items-center px-2 rounded-r-md focus:outline-hidden",
                                                "aria-label": "Expand Button"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(ChevronDownIcon), {
                                                    "aria-hidden": "true",
                                                    class: "w-5 h-5 text-clay-800"
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(ComboboxOptions), { class: "absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-hidden sm:text-sm" }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(shows), (show) => {
                                                    return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                                      key: show.id,
                                                      value: show,
                                                      as: "template"
                                                    }, {
                                                      default: _withCtx(({ active, selected }) => [
                                                        _createElementVNode("li", {
                                                          class: _normalizeClass(['relative cursor-default select-none py-2 pl-8 pr-4', active ? 'bg-clay-600 text-white' : 'text-gray-900'])
                                                        }, [
                                                          _createElementVNode("div", _hoisted_68, [
                                                            (show.logo)
                                                              ? (_openBlock(), _createElementBlock("img", {
                                                                  key: 0,
                                                                  src: show.logo,
                                                                  class: "w-5 h-5 mr-2 shrink-0"
                                                                }, null, 8, _hoisted_69))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("span", {
                                                              class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                                                            }, _toDisplayString(show.title) + " (" + _toDisplayString(show.category) + ") ", 3),
                                                            selected
                                                              ? (_openBlock(), _createElementBlock("span", {
                                                                  key: 1,
                                                                  class: _normalizeClass(['absolute inset-y-0 left-0 flex items-center pl-1.5', active ? 'text-white' : 'text-clay-600'])
                                                                }, [
                                                                  _createVNode(_unref(CheckIcon), {
                                                                    "aria-hidden": "true",
                                                                    class: "w-5 h-5"
                                                                  })
                                                                ], 2))
                                                              : _createCommentVNode("", true)
                                                          ])
                                                        ], 2)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"]),
                                        (selectedShow.value?.id)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_70, [
                                              (selectedShow.value.logo)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: selectedShow.value.logo,
                                                    class: "inline-block w-5 h-5 mr-2"
                                                  }, null, 8, _hoisted_71))
                                                : _createCommentVNode("", true),
                                              _createElementVNode("a", {
                                                href: `/${selectedShow.value.urlSlug}`,
                                                target: "_blank",
                                                class: "font-normal underline text-clay-600 hover:text-clay-700"
                                              }, _toDisplayString(selectedShow.value.title), 9, _hoisted_72)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_73, [
                                      _cache[43] || (_cache[43] = _createElementVNode("hr", { class: "border-gray-200" }, null, -1)),
                                      _createElementVNode("div", _hoisted_74, [
                                        _cache[38] || (_cache[38] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "address"
                                        }, [
                                          _createTextVNode("Audition/Interview Location "),
                                          _createElementVNode("span", { class: "text-xs text-clay-800" }, "(optional)")
                                        ], -1)),
                                        _createVNode(VueGoogleAutocomplete, {
                                          id: "address",
                                          name: "address",
                                          class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                                          placeholder: "Start typing",
                                          types: "address",
                                          ref_key: "addressInput",
                                          ref: addressInput,
                                          onPlacechanged: onPlaceChanged
                                        }, null, 512),
                                        _cache[39] || (_cache[39] = _createElementVNode("label", { class: "label" }, [
                                          _createElementVNode("span", { class: "text-sm text-clay-800" }, "e.g. 1234 Broadway, New York, NY 10001")
                                        ], -1))
                                      ]),
                                      _createElementVNode("div", _hoisted_75, [
                                        _cache[40] || (_cache[40] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "webUrl"
                                        }, "Website URL", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          id: "webUrl",
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(updateRequest).webUrl) = $event)),
                                          class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                                          name: "webUrl",
                                          placeholder: "e.g. https://stageagent.com",
                                          type: "text"
                                        }, null, 512), [
                                          [_vModelText, _unref(updateRequest).webUrl]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_76, [
                                        _cache[41] || (_cache[41] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "email"
                                        }, "Email ", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          id: "email",
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(updateRequest).email) = $event)),
                                          class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                                          name: "email",
                                          placeholder: "e.g. info@stageagent.com",
                                          type: "email"
                                        }, null, 512), [
                                          [_vModelText, _unref(updateRequest).email]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_77, [
                                        _cache[42] || (_cache[42] = _createElementVNode("label", {
                                          class: "block font-bold tracking-tight font-display text-clay-950",
                                          for: "phone"
                                        }, "Phone", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          id: "phone",
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(updateRequest).phone) = $event)),
                                          class: "block w-full px-3 py-2 mt-1 border border-clay-500 rounded-md shadow-sm focus:outline-hidden focus:ring-clay-800 focus:border-clay-800 sm:text-sm",
                                          name: "phone",
                                          placeholder: "e.g. 2145541234",
                                          type: "text"
                                        }, null, 512), [
                                          [_vModelText, _unref(updateRequest).phone]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_78, [
                                      _createVNode(SaButton, {
                                        onClick: _withModifiers(submit, ["prevent"]),
                                        loading: isSubmitting.value,
                                        variant: "primary"
                                      }, {
                                        loading: _withCtx(() => _cache[44] || (_cache[44] = [
                                          _createElementVNode("span", { class: "font-semibold" }, "Updating...", -1)
                                        ])),
                                        default: _withCtx(() => [
                                          _cache[45] || (_cache[45] = _createElementVNode("span", { class: "font-semibold" }, "Update Opportunity", -1))
                                        ]),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                      _cache[46] || (_cache[46] = _createElementVNode("p", null, "Need to remove this opportunity?", -1)),
                                      _createElementVNode("a", {
                                        class: "inline-flex justify-center px-4 py-2 text-sm font-medium text-white uppercase bg-gray-500 border border-transparent rounded-md hover:shadow-lg",
                                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (openConfirmation(_unref(opportunity))), ["prevent"]))
                                      }, " Delete Opportunity ")
                                    ])
                                  ]))
                            ]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: isOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: closeConfirmation
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createVNode(_unref(DialogPanel), { class: "relative px-4 pt-5 pb-4 overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:max-w-lg sm:w-full sm:p-6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(_unref(TrashIcon), {
                          class: "w-6 h-6 text-red-600",
                          "aria-hidden": "true"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_83, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg font-medium leading-6 text-gray-900"
                        }, {
                          default: _withCtx(() => _cache[49] || (_cache[49] = [
                            _createTextVNode("Confirm Delete ")
                          ])),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("p", _hoisted_85, [
                            _cache[50] || (_cache[50] = _createTextVNode("Opportunity ")),
                            _createElementVNode("strong", null, "\"" + _toDisplayString(opportunityToDelete.value.title) + "\"", 1),
                            _cache[51] || (_cache[51] = _createTextVNode(" will be permanently deleted. This action might take sometime to reflect in your account. "))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:col-start-2 sm:text-sm",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (deleteOpportunity(opportunityToDelete.value)))
                      }, "Yes "),
                      _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-clay-500 rounded-md shadow-sm hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-electric-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        onClick: closeConfirmation
                      }, "Cancel ")
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})